/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-southeast-2",
    "aws_cloud_logic_custom": [
        {
            "name": "cancelReservationAPI",
            "endpoint": "https://txte69qxt8.execute-api.ap-southeast-2.amazonaws.com/uat",
            "region": "ap-southeast-2"
        },
        {
            "name": "deskAPI",
            "endpoint": "https://vbextnw8gc.execute-api.ap-southeast-2.amazonaws.com/uat",
            "region": "ap-southeast-2"
        },
        {
            "name": "emailNotificationAPI",
            "endpoint": "https://a6gazuubdl.execute-api.ap-southeast-2.amazonaws.com/uat",
            "region": "ap-southeast-2"
        },
        {
            "name": "reservationAPI",
            "endpoint": "https://c3es5ovrk8.execute-api.ap-southeast-2.amazonaws.com/uat",
            "region": "ap-southeast-2"
        },
        {
            "name": "siteAPI",
            "endpoint": "https://8ywa5pe8qh.execute-api.ap-southeast-2.amazonaws.com/uat",
            "region": "ap-southeast-2"
        },
        {
            "name": "userBookingsAPI",
            "endpoint": "https://g4lxd7sl7h.execute-api.ap-southeast-2.amazonaws.com/uat",
            "region": "ap-southeast-2"
        },
        {
            "name": "validationAPI",
            "endpoint": "https://xsyd85ww77.execute-api.ap-southeast-2.amazonaws.com/uat",
            "region": "ap-southeast-2"
        }
    ],
    "aws_cognito_identity_pool_id": "ap-southeast-2:b00853f3-3de8-43c8-ba78-fb5e64e83416",
    "aws_cognito_region": "ap-southeast-2",
    "aws_user_pools_id": "ap-southeast-2_oaydBg6xF",
    "aws_user_pools_web_client_id": "rgsq46ivrgohgtlpke37tnshq",
    "oauth": {
        "domain": "justbookit-fbau-uat.auth.ap-southeast-2.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://uat.justbookit-fbau.fujifilm.com/",
        "redirectSignOut": "https://uat.justbookit-fbau.fujifilm.com/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "ap-southeast-2",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "JbiDeskTable-uat",
            "region": "ap-southeast-2"
        },
        {
            "tableName": "JbiReservationTable-uat",
            "region": "ap-southeast-2"
        },
        {
            "tableName": "JbiSiteTable-uat",
            "region": "ap-southeast-2"
        }
    ]
};


export default awsmobile;
